
























import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonAddTreatment extends Vue {
  isEditMode = false;
  created() {
    this.isEditMode = this.$route.meta.mode === "EDIT";
  }

  onSaveTreatment() {
    this.$store.commit("SAVE_TREATMENT_CLICK");
  }
  getRouteCancel() {
    return this.$router.push("/treatments/database");
  }
}
